import { Component, HostListener } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogService } from "./dialog.service";

/**
 * The single app-wide confirmation/alert dialog. Rendered once in
 * AppComponent; driven entirely by DialogService. Backdrop is static
 * (click does nothing), Escape cancels — matching the existing
 * `backdrop: 'static'` convention of the modals it replaces.
 */
@Component({
  selector: "app-confirm-dialog",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent {
  constructor(public dialog: DialogService) {}

  @HostListener("document:keydown.escape")
  onEscape() {
    if (this.dialog.active()) {
      this.dialog.close(false);
    }
  }
}
